import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import type { Theme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useMutation } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import apiService from 'v2/services/api';

import useStyles from './styles';

export interface ModalNewsRVPProps {
  available?: boolean;
}

export const ModalNewsRVP = React.memo(({ available }: ModalNewsRVPProps) => {
  const classes = useStyles();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));

  const [opened, setOpened] = React.useState(false);

  const disabledInThisSession = !!sessionStorage.getItem('disabled-products-without-rvp');

  const activate = useMutation(() => apiService.put('/products-without-rvp/activate', {}).toPromise(), {
    onSuccess: () => {
      toast.success('Ativação realizada com sucesso!');
      setOpened(false);
    },
  });

  const handleActivate = () => {
    activate.mutate();
  };

  const handleClose = () => {
    sessionStorage.setItem('disabled-products-without-rvp', 'true');
    setOpened(false);
  };

  useEffect(() => {
    setOpened(true);
  }, []);

  return (
    <Dialog
      open={opened && available && !disabledInThisSession}
      onClose={handleClose}
      fullScreen={isMobile}
      scroll='paper'
      classes={{
        paper: classes.paper,
      }}
      disableBackdropClick
    >
      <DialogTitle>Temos uma ferramenta poderosa e totalmente gratuita para você aproveitar!</DialogTitle>
      <DialogContent className={classes.content} dividers>
        <DialogContentText className={classes.contentText} tabIndex={-1}>
          A <b>Recuperação de Vendas Perdidas (RVP)</b> já está disponível para você, mas ainda não está ativa em seus produtos. Recupere vendas não
          finalizadas e aumente sua conversão em até <b>15%</b> sem esforço!
        </DialogContentText>
        <DialogContentText className={classes.contentText} tabIndex={-1}>
          <b>Que tal ativar agora?</b>
        </DialogContentText>
        <DialogContentText className={classes.contentText} tabIndex={-1}>
          <i>Você pode alterar essa configuração a qualquer momento na edição de cada produto.</i>
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button variant='text' onClick={handleClose}>
          Quero ativar mais tarde
        </Button>
        <Button variant='contained' onClick={handleActivate} color='primary'>
          Sim, ativar RVP!
        </Button>
      </DialogActions>
    </Dialog>
  );
});
